import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { ProductService, NuvemShopOauthResponse } from 'src/app/services/product.service';
import { AuthService } from 'src/app/services/auth.service';
import { MessageService, ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-nuvemshop-auth',
  templateUrl: './nuvemshop-auth.component.html',
  styleUrls: ['./nuvemshop-auth.component.scss'],
  providers: [ConfirmationService]
})
export class NuvemShopAuthComponent implements OnInit {
  loading = true;
  errorMessage = '';
  private integrationData: NuvemShopOauthResponse | null = null;
  private providerStoreId: string | null = null;
  private selectedStoreId = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private productService: ProductService,
    private errorHandler: ErrorHandlerService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(async params => {
      await this.ensureStorageFromOpener();

      const code = params['code'];
      const storeId = params['store_id'] || params['storeId'];
      const state = params['state'];
      const error = params['error'];

      if (error) {
        this.showError('Autorização negada na Nuvemshop.');
        return;
      }

      const statePayload = this.restoreStateIfNeeded(state);
      this.selectedStoreId =
        statePayload?.selectedStoreId ||
        localStorage.getItem('ss_SelectedStoreId') || '';

      const resolvedStoreId =
        storeId ||
        statePayload?.store_id ||
        statePayload?.selectedStoreId ||
        this.selectedStoreId;

      if (code && resolvedStoreId) {
        this.providerStoreId = resolvedStoreId;
        this.finishNuvemshopLogin(code, resolvedStoreId, state);
      } else {
        this.showError('Parâmetros obrigatórios não informados pela Nuvemshop.');
      }
    });
  }

  private finishNuvemshopLogin(code: string, storeId: string, state?: string): void {
    this.productService.nuvemshopOauth(code, storeId, state).subscribe({
      next: (response) => {
        this.integrationData = response;
        this.autoIntegrate();
      },
      error: () => {
        this.showError('Não foi possível concluir a autenticação com a Nuvemshop.');
      }
    });
  }

  private autoIntegrate(): void {
    if (!this.selectedStoreId || !this.integrationData) {
      this.showError('Loja não identificada. Tente novamente.');
      return;
    }

    localStorage.setItem('ss_SelectedStoreId', this.selectedStoreId);

    const payload = {
      access_token: this.integrationData.access_token,
      refresh_token: this.integrationData.refresh_token,
      status: 'active',
      form_value: {
        domain: this.integrationData.domain || null,
        store_id: this.integrationData.store_id || this.providerStoreId,
        store_name: this.integrationData.store_name || null,
      },
    };

    this.productService.createAppsStore2('nuvemshop', payload).subscribe({
      next: () => {
        this.loading = false;
        // const isAndroid = /android/i.test(navigator.userAgent);
        // if (isAndroid) {
        //   window.location.href = 'myslick://auth/nuvemshop?result=success';
        //   return;
        // }
        try {
          const channel = new BroadcastChannel('oauth-channel');
          channel.postMessage({ type: 'nuvemshop-connected' });
          channel.close();
        } catch {}
        try { window.close(); } catch {}
      },
      error: (error) => {
        this.loading = false;
        if (error.error?.error === 'duplicate_integration') {
          this.errorMessage = 'Esta loja já está vinculada a outra conta.';
          this.confirmationService.confirm({
            message: 'Esta loja já está vinculada a outra conta.',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Saiba mais',
            rejectLabel: 'Fechar',
            accept: () => window.open('https://helpcenterslicksell.tawk.help/article/integracao-com-nuvemshop', '_blank'),
            reject: () => { try { window.close(); } catch {} },
          });
          return;
        }
        this.showError('Não foi possível salvar integração.');
      }
    });
  }

  private showError(msg: string) {
    this.loading = false;
    this.errorMessage = msg;
    this.messageService.add({ severity: 'error', summary: 'Erro', detail: msg });
    setTimeout(() => { try { window.close(); } catch {} }, 3000);
  }

  private restoreStateIfNeeded(state?: string): any | null {
    if (!state) return null;
    try {
      const parsed = JSON.parse(atob(state));
      if (parsed?.selectedStoreId) localStorage.setItem('ss_SelectedStoreId', parsed.selectedStoreId);
      if (parsed?.accessToken) localStorage.setItem('access_token', parsed.accessToken);
      return parsed;
    } catch {
      return null;
    }
  }

  private ensureStorageFromOpener(): Promise<void> {
    return new Promise((resolve) => {
      try {
        const ch = new BroadcastChannel('oauth-storage');
        const timeout = setTimeout(() => { ch.close(); resolve(); }, 1200);
        ch.onmessage = (e) => {
          if (e.data?.type === 'storage-dump') {
            const p = e.data.payload || {};
            for (const k of Object.keys(p)) {
              if (p[k] != null) localStorage.setItem(k, String(p[k]));
            }
            clearTimeout(timeout);
            ch.close();
            resolve();
          }
        };
        ch.postMessage({ type: 'request-storage' });
      } catch { resolve(); }
    });
  }
}
